import React, { Component } from "react";
import { connect } from "react-redux";
import QR from "qrcode.react";

import { Translate, I18n } from "react-redux-i18n";

import QRCode from "./modals/QRCode";

import "../../../styles/components/account/manageAccount/QR.scss";
import evio_o from "../../../styles/images/evio_o.svg";

class UserQR extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      showQR: false,
    };
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    const imageSettings = {
      ...(this.props.brand?.brandName === "EVIO" && {
        imageSettings: {
          src: evio_o,
          width: 8,
          height: 8,
          x: 9,
          y: 9,
        },
      }),
    };

    return (
      <>
        <div
          id="qr"
          className="evio-container"
          onClick={() => this.safeSetState({ showQR: true })}
        >
          <div className="qr-code-container">
            <div className="details-container">
              <div className="title">
                <p>
                  <Translate value="accountDetails_qrCodeId" />
                </p>
              </div>
              <p>
                <Translate value="accountDetails_qrCodeInfo" />
              </p>
            </div>
            <div className="qr-container">
              <QR
                value={this.props.prefix + this.props.phone}
                size={80}
                bgColor="transparent"
                fgColor="#353841"
                {...imageSettings}
              />
            </div>
          </div>
        </div>

        <QRCode
          show={this.state.showQR}
          onHide={() => this.safeSetState({ showQR: false })}
        />
      </>
    );
  }
}

const mapStateToProps = state => ({
  prefix: state.account.accountData.internationalPrefix,
  phone: state.account.accountData.phone,
  brand: state.app.brand,
});

export default connect(mapStateToProps, null)(UserQR);
